// src/hooks/useDraggableMarkerOnClick.js
// Muestra un marcador estático en el mapa cuando hay coordenadas capturadas.
// La captura se realiza via CenterMarkerOverlay (marcador central + GPS).

import { useEffect, useRef, useCallback } from 'react'
import mapboxgl from 'mapbox-gl'
// import IconPoint2 from '../assets/images/icon-tree/map-pin-solid.png'
// import IconPoint2 from '../assets/images/icon-tree/tree.png'
import IconPoint2 from '../assets/images/icon-tree/summer.png'

export const useDraggableMarkerOnClick = ({
  map,
  enabled,
  coords,
  onCoordsChange,
  selectedTenant = null,
}) => {
  const markerRef = useRef(null)
  const onCoordsChangeRef = useRef(onCoordsChange)
  onCoordsChangeRef.current = onCoordsChange

  const clearMarker = useCallback(() => {
    if (markerRef.current) {
      markerRef.current.remove()
      markerRef.current = null
    }
  }, [])

  // Limpiar marcador Y coords solo cuando cambia el tenant (el marker viejo ya no es válido)
  const prevTenantRef = useRef(selectedTenant)
  useEffect(() => {
    if (prevTenantRef.current !== selectedTenant) {
      prevTenantRef.current = selectedTenant
      clearMarker()
      onCoordsChangeRef.current(null)
    }
  }, [selectedTenant, clearMarker])

  // Marcador estático cuando NO está en modo captura y hay coords
  useEffect(() => {
    if (!map || enabled || !coords) {
      clearMarker()
      return
    }

    // Guard against out-of-range coordinates to prevent Mapbox crash
    if (
      coords.lat == null ||
      coords.lng == null ||
      coords.lat < -90 ||
      coords.lat > 90 ||
      coords.lng < -180 ||
      coords.lng > 180
    ) {
      clearMarker()
      return
    }

    clearMarker()

    const el = document.createElement('img')
    el.src = IconPoint2
    el.style.width = '100px'
    el.style.height = '100px'

    markerRef.current = new mapboxgl.Marker({
      element: el,
      draggable: false,
      anchor: 'bottom',
    })
      .setLngLat([coords.lng, coords.lat])
      .addTo(map)

    return () => clearMarker()
  }, [map, enabled, coords, clearMarker])

  // Cleanup general al desmontar
  useEffect(() => {
    return () => clearMarker()
  }, [clearMarker])
}
